import React from "react";
import TitleAndPagination from "../components/Pagination";
import { useMediaQuery } from "react-responsive";
import { useEffect } from "react";
import { useState } from "react";
import { useSelector } from "react-redux";
import { getFavourites } from "../services/btc-api.service";
import Title from "../components/Title";
import PurchaseTable from "../components/PurchaseTable";
export default function Purchase() {

    const isMobile = useMediaQuery({ query: '(max-width: 768px)' })
    const [limit, setLimit] = useState(10)
    const [offset, setOffSet] = useState(0)
    const [favourties, setFavourties] = useState()
    const [totalRecords, setTotalRecords] = useState()
    const user = useSelector((state) => state.user.user);
    useEffect(() => {
        if (user && user._id) {
            getData()
        }
    }, [user, limit, offset])

    const getData = async () => {

        const data = await getFavourites(limit, offset, user && user._id ? user._id : undefined);

        setFavourties(data.records)
        setTotalRecords(data.totalRecords)
    }
    const handleLimit = (e) => {
        setLimit(e)
    }
    const handlePageChange = (e) => {
        setOffSet(e)
    }
    return (
        <>
            <Title text="Purchase Record" />
            <table className="bids-table-purchase" style={{ border: "2px solid white" }}>
                <tbody>
                    <tr>
                        <td className="bold-and-black-p">Advance Amount</td>
                        <td className="bold-and-black">
                            {/* {vehicle.discountPrice.toLocaleString()} */}
                            300,000 JPY
                        </td>
                    </tr>
                    <tr>
                        <td className="bold-and-black-p">Invoice Amount </td>
                        <td className="bold-and-black">
                            400,000 JPY
                        </td>
                    </tr>
                    <tr>
                        <td className="bold-and-black-p">Payment Amount </td>
                        <td className="bold-and-black">
                            {/* {vehicle.discountPrice.toLocaleString()} */}
                            800,000 JPY
                        </td>
                    </tr>
                    <tr>
                        <td className="bold-and-black-p">Balance</td>
                        <td className="bold-and-black">
                            200,000 JPY
                        </td>
                    </tr>
                </tbody>
            </table>

            <div className="auction-page  container-fluid" >
                <TitleAndPagination handlePageChange={handlePageChange} handleLimit={handleLimit} title={'Purchase List'} totalRecords={totalRecords} limit={limit} />
                {<PurchaseTable rows={favourties} isMobile={isMobile} style={{ paddingLeft: isMobile ? 10 : 40, marginTop: 50 }} rowColor />}
            </div>
        </>
    );
}
